import type { AppSchema } from './http/types';

import { APP_CENTER_BASE_PATH, type SearchParamsPageProps } from '#/utils/const';

export const categoryIdInFilter = (filters: number[], categoryId: number) =>
  filters.length === 0 || (filters.length > 0 && filters.includes(categoryId));

export const appInQuery = (appName: string, query?: string) => {
  if (query) {
    const sanitizedAppName = appName.toLowerCase().trim().replace(/\s/g, '');
    const sanitizedQuery = query.toLowerCase().trim().replace(/\s/g, '');
    return sanitizedAppName.includes(sanitizedQuery);
  }
  return true;
};

export function parseSearchParamsPagePropsToURLSearchParams(
  searchParams: SearchParamsPageProps
): URLSearchParams {
  const urlSearchParams = new URLSearchParams();

  Object.entries(searchParams).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // If the value is an array, add each item separately
      value.forEach((item) => urlSearchParams.append(key, item));
    } else {
      // Add the key-value pair to URLSearchParams
      urlSearchParams.append(key, value || '');
    }
  });

  return urlSearchParams;
}

export function getProdCanonicalUrl(currApp: AppSchema, isRelative = false) {
  if (currApp.isTestApp) {
    throw new Error('can only be used for prod apps');
  }

  const slugifiedTitle = encodeURIComponent(currApp.name).replaceAll('%20', '-');

  return `${isRelative ? '/app-center' : APP_CENTER_BASE_PATH}/detail/${slugifiedTitle}/${currApp.id}`;
}

export function getIframePageUrl(currApp: AppSchema, isRelative = false) {
  return `${isRelative ? '/app-center' : APP_CENTER_BASE_PATH}/${currApp.isTestApp ? 'test/' : ''}apps/${currApp.id}`;
}
